// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a5h0","left":"styles_left__3mvmw"};